<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:15:09
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-05-27 09:45:45
 * @Description: 新增数据，分卫星展示
 -->
<template>
  <div class="observe-trend-satellite">
    <div class="observe-trend-satellite__chart">
      <!-- 按钮 -->
      <div class="observe-trend-satellite__switch-container">
        <span :class="['observe-trend-satellite__switch-btn', chartType === 'view' ? 'observe-trend-satellite__switch-btn--active' : null]" @click="chartChangeView('prev')">分卫星景数</span>
        <span :class="['observe-trend-satellite__switch-btn', chartType === 'size' ? 'observe-trend-satellite__switch-btn--active' : null]" @click="chartChangeSize('next')">分卫星数据量</span>
        <switch-check class="observe-trend-satellite__switch-check" @checkChange="checkChange" :checked="isCloudData" value1="上云" value2="推送"></switch-check>
      </div>
      <!-- 左右 icon -->
      <div v-show="swiperIndex !== 0"
        class="observe-trend-satellite__switch-icon observe-trend-satellite__switch-icon--left"
        @click="chartChange('prev')">
      </div>
      <div v-show="swiperIndex !== 7"
        class="observe-trend-satellite__switch-icon observe-trend-satellite__switch-icon--right"
        @click="chartChange('next')">
      </div>
      <!-- echart 图表 -->
      <div class="observe-trend-satellite__chart-container swiper-container" ref="swiper-container">
        <div class="swiper-wrapper">
          <div class="observe-trend-satellite__chart-view swiper-slide" ref="dayViewChart"></div>
          <div class="observe-trend-satellite__chart-view swiper-slide" ref="dayViewPushChart"></div>
          <div class="observe-trend-satellite__chart-size swiper-slide" ref="daySizeChart"></div>
          <div class="observe-trend-satellite__chart-size swiper-slide" ref="daySizePushChart"></div>
          <div class="observe-trend-satellite__chart-view swiper-slide" ref="weekViewChart"></div>
          <div class="observe-trend-satellite__chart-view swiper-slide" ref="weekViewPushChart"></div>
          <div class="observe-trend-satellite__chart-size swiper-slide" ref="weekSizeChart"></div>
          <div class="observe-trend-satellite__chart-size swiper-slide" ref="weekSizePushChart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Swiper from 'swiper'
// import 'swiper/css/swiper.css'
import SwitchCheck from '@/components/switch-check'
import { mapGetters } from 'vuex'
// import {
//   LASTEST_WEEK_INFO,
//   GET_RECENT_PERIOD,
// } from '@/assets/const-value/interface'

/**
 * 设置 moment 的语言环境
 */
moment.locale('fr', {
  week: {
    dow: 1, // 星期一是一周的第一天
    doy: 4, // 判断一年中的第一周
  },
})
// const PERIOD_DATA = [{
//   title: '日',
//   value: 'day',
//   key: 4,
// }, {
//   title: '周',
//   value: 'week',
//   key: 3,
// }]
export default {
  components: {
    SwitchCheck,
  },
  data() {
    return {
      swiper: null,
      swiperIndex: 0,
      chartType: 'view', // 可选 'view','size'
      isCloudData: true, // 是上云数据还是推送数据
    }
  },
  computed: {
    ...mapGetters({
      // trendPeriod: 'page/trendPeriod',
      dataTrend: 'page/dataTrend',
    }),
  },
  watch: {
    dataTrend() {
      this.getData()
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper()
    })
  },
  methods: {
    initSwiper() {
      // eslint-disable-next-line no-new
      this.swiper = new Swiper(this.$refs['swiper-container'], {
        loop: false, // 循环
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        touchStartPreventDefault: false, // 添加该属性
        on: {
          slideChange: this.slideChange,
        },
      })
    },
    slideChange() {
      const { activeIndex } = this.swiper
      this.swiperIndex = activeIndex
      // const periodIndex = Math.floor(activeIndex / 2)
      // this.periodSelect = PERIOD_DATA[periodIndex]

      const bol = Boolean(activeIndex === 2 || activeIndex === 3 || activeIndex === 6 || activeIndex === 7)
      this.chartType = bol ? 'size' : 'view'
      this.isCloudData = activeIndex % 2 === 0
    },
    /**
     * @description: 切换图表
     * @param {type} String 控制切换方向，'prev','next'
     */
    chartChange(direction) {
      if (direction === 'next') {
        this.swiper.slideNext()
      } else {
        this.swiper.slidePrev()
      }
    },
    chartChangeView() {
      const { activeIndex } = this.swiper
      const bol = Boolean((activeIndex + 1) % 3 === 0 || (activeIndex + 1) % 4 === 0)
      if (bol) {
        this.swiper.slideTo(activeIndex - 2)
      }
    },
    chartChangeSize() {
      const { activeIndex } = this.swiper
      const bol = Boolean((activeIndex + 1) % 3 === 0 || (activeIndex + 1) % 4 === 0)
      if (!bol) {
        this.swiper.slideTo(activeIndex + 2)
      }
    },
    /**
     * @description: 选择器事件
     */
    checkChange() {
      this.isCloudData = !this.isCloudData
      if (this.isCloudData) {
        this.swiper.slidePrev()
      } else {
        this.swiper.slideNext()
      }
    },
    /**
     * @description: 获取图表数据
     */
    async getData() {
      if (!this.cloudView) {
        const sateNames = {
          // 106: 'ZY1-02C',
          116: 'ZY1-02D',
          52: 'ZY1-02E',
          // 111: 'ZY3-01',
          115: 'ZY3-02',
          118: 'ZY3-03',
          7: '2m/8m星',
          109: 'GF-1',
          92: 'GF-2',
          55: 'GF-5A',
          54: 'GF-5B',
          91: 'GF-6',
          105: 'GF-7',
          119: 'CBERS-04A',
          122: 'L-SAR',
        }
        // 上云数据-----day
        const dayCloudData = {
          axis: [],
        }
        this.dataTrend[0].data.forEach((sate, i) => {
          const obj = {
            view: [],
            size: [],
          }
          sate.data.sort((a, b) => a.period - b.period).forEach((item) => {
            if (i === 0) {
              const time = moment(item.period, 'YYYYMMDD').format('MM-DD')
              dayCloudData.axis.push(time)
            }
            obj.view.push(item.numCurrent)
            obj.size.push(parseFloat((item.sizeCurrent / 1024 / 1024 / 1024 / 1024).toFixed(2)))
          })
          const name = sateNames[sate.satelliteId]
          dayCloudData[name] = obj
        })
        // 推送数据------day
        const dayPushData = {
          axis: [],
        }
        this.dataTrend[1].data.forEach((sate, i) => {
          const obj = {
            view: [],
            size: [],
          }
          sate.data.sort((a, b) => a.period - b.period).forEach((item) => {
            if (i === 0) {
              const time = moment(item.period, 'YYYYMMDD').format('MM-DD')
              dayPushData.axis.push(time)
            }
            obj.view.push(item.numCurrent)
            obj.size.push(parseFloat((item.sizeCurrent / 1024 / 1024 / 1024 / 1024).toFixed(2)))
          })
          const name = sateNames[sate.satelliteId]
          dayPushData[name] = obj
        })

        // 上云数据-------week
        const weekCloudData = {
          axis: [],
        }
        this.dataTrend[2].data.forEach((sate, i) => {
          const obj = {
            view: [],
            size: [],
          }
          const sortArr = sate.data.sort((a, b) => a.period - b.period)
          sortArr.forEach((item, k) => {
            if (i === 0) {
              if (k === 0) weekCloudData.axis.push(moment(sortArr[0].period, 'YYYYww').startOf('week').format('MM-DD'))
              const time = moment(item.period, 'YYYYww').endOf('week').add(1, 'days').format('MM-DD')
              weekCloudData.axis.push(time)
            }
            obj.view.push(item.numCurrent)
            obj.size.push(parseFloat((item.sizeCurrent / 1024 / 1024 / 1024 / 1024).toFixed(2)))
          })
          const name = sateNames[sate.satelliteId]
          weekCloudData[name] = obj
        })
        // 推送数据------week
        const weekPushData = {
          axis: [],
        }
        this.dataTrend[3].data.forEach((sate, i) => {
          const obj = {
            view: [],
            size: [],
          }
          const sortArr = sate.data.sort((a, b) => a.period - b.period)
          sortArr.forEach((item, j) => {
            if (i === 0) {
              if (j === 0) weekPushData.axis.push(moment(sortArr[0].period, 'YYYYww').startOf('week').format('MM-DD'))
              const time = moment(item.period, 'YYYYww').endOf('week').add(1, 'days').format('MM-DD')
              weekPushData.axis.push(time)
            }
            obj.view.push(item.numCurrent)
            obj.size.push(parseFloat((item.sizeCurrent / 1024 / 1024 / 1024 / 1024).toFixed(2)))
          })
          const name = sateNames[sate.satelliteId]
          weekPushData[name] = obj
        })

        if (dayCloudData.axis.length) this.initViewChart(dayCloudData, 'view', 'dayViewChart', 'day')
        if (dayCloudData.axis.length) this.initSizeChart(dayCloudData, 'size', 'daySizeChart', 'day')
        if (dayPushData.axis.length) this.initViewChart(dayPushData, 'view', 'dayViewPushChart', 'day')
        if (dayPushData.axis.length) this.initSizeChart(dayPushData, 'size', 'daySizePushChart', 'day')
        if (weekCloudData.axis.length) this.initViewChart(weekCloudData, 'view', 'weekViewChart')
        if (weekCloudData.axis.length) this.initSizeChart(weekCloudData, 'size', 'weekSizeChart')
        if (weekPushData.axis.length) this.initViewChart(weekPushData, 'view', 'weekViewPushChart')
        if (weekPushData.axis.length) this.initSizeChart(weekPushData, 'size', 'weekSizePushChart')
      }
    },
    /**
     * @description: 设定配置项
     */
    initViewChart(chartData, type, domRef, isDay) {
      const yAxisName = ' 景 '
      const option = this.getOption({
        yAxisName, chartData, type, isDay,
      })

      const chartView = this.$echarts.init(this.$refs[domRef])
      chartView.setOption(option)
    },
    initSizeChart(chartData, type, domRef, isDay) {
      const yAxisName = ' T '
      // const chartData = this.isCloudData ? this.cloudData : this.pushData
      // const chartData = this.cloudSize
      const option = this.getOption({
        yAxisName, chartData, type, isDay,
      })

      const chartSize = this.$echarts.init(this.$refs[domRef])
      chartSize.setOption(option)
    },
    getOption({
      yAxisName, chartData, type, isDay,
    }) {
      const xAxisData = [ ...chartData.axis ]

      const legendData = [ 'ZY1-02D', 'ZY1-02E', 'ZY3-02', 'ZY3-03', '2m/8m星', 'GF-1', 'GF-2', 'GF-5A', 'GF-5B', 'GF-6', 'GF-7', 'CBERS-04A', 'L-SAR' ]
      const series = legendData.map((item) => {
        let data = 0
        if (chartData[item]) {
          data = chartData[item][type]
        }
        return {
          type: 'line',
          // stack: 'abc',
          xAxisIndex: isDay ? 0 : 1,
          name: item,
          smooth: true,
          data,
        }
      })
      if (!isDay) xAxisData.pop()
      return {
        legend: [{
          data: [ 'ZY1-02D', 'ZY1-02E' ],
          left: 84,
          top: 5,
          orient: 'vertical',
          textStyle: {
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontSize: 14,
            color: '#737373',
            padding: [ 5, 0, 0, 0 ],
          },
          itemWidth: 20,
          itemHeight: 12,
        }, {
          data: [ 'ZY3-02', 'ZY3-03' ],
          left: 174,
          top: 5,
          orient: 'vertical',
          textStyle: {
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontSize: 14,
            color: '#737373',
            padding: [ 5, 0, 0, 0 ],
          },
          itemWidth: 20,
          itemHeight: 12,
        }, {
          data: [ '2m/8m星', 'CBERS-04A' ],
          left: 256,
          top: 5,
          orient: 'vertical',
          textStyle: {
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontSize: 14,
            color: '#737373',
            padding: [ 5, 0, 0, 0 ],
          },
          itemWidth: 20,
          itemHeight: 12,
        }, {
          data: [ 'GF-1', 'GF-2' ],
          left: 366,
          top: 5,
          orient: 'vertical',
          textStyle: {
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontSize: 14,
            color: '#737373',
            padding: [ 5, 0, 0, 0 ],
          },
          itemWidth: 20,
          itemHeight: 12,
        }, {
          data: [ 'GF-5A', 'GF-5B' ],
          left: 434,
          top: 5,
          orient: 'vertical',
          textStyle: {
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontSize: 14,
            color: '#737373',
            padding: [ 5, 0, 0, 0 ],
          },
          itemWidth: 20,
          itemHeight: 12,
        }, {
          data: [ 'GF-6', 'GF-7' ],
          left: 512,
          top: 5,
          orient: 'vertical',
          textStyle: {
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontSize: 14,
            color: '#737373',
            padding: [ 5, 0, 0, 0 ],
            textAlign: 'center',
            align: 'center',
          },
          itemWidth: 20,
          itemHeight: 12,
        }, {
          data: [ 'L-SAR' ],
          left: 582,
          top: 5,
          orient: 'vertical',
          textStyle: {
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontSize: 14,
            color: '#737373',
            padding: [ 5, 0, 0, 0 ],
            textAlign: 'center',
            align: 'center',
          },
          itemWidth: 20,
          itemHeight: 12,
        }],
        color: [ '#DB3F3F', '#3d377c', '#C16464', '#EFA21F', '#37C3E3', '#BF6312', '#D953B7', '#008000', '#8B4CE2', '#4774E7', '#8CD42B', '#159DF8', '#FFE000' ],
        tooltip: {
          trigger: 'axis',
          formatter: (e,) => {
            let title = `${e[0].name} <br/>`
            e.forEach((item) => {
              title += ` ${item.marker} <div style="display: inline-block; width:90px; ">${item.seriesName}: </div> ${item.value} <br/>`
              // title += `${item.marker} <div style="display: inline-block; width:70px; ">${item.seriesName}: </div> ${item.value}${yAxisName}<br/>`
            })
            return title
          },
        },
        grid: {
          top: 90,
          right: 35,
          left: 90,
          bottom: 70,
        },
        xAxis: [
          {
            type: 'category',
            data: chartData.axis,
            boundaryGap: false,
            axisPointer: {
              show: !!isDay,
            },
            axisLine: {
              show: true,
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              color: '#737373',
              // rotate: 45,
              margin: 15,
              textStyle: {
                fontSize: 16,
                fontFamily: 'PingFangSC-Regular,PingFang SC',
              },
            },
          },
          {
            type: 'category',
            data: xAxisData,
            axisPointer: {
              show: !isDay,
            },
            axisTick: {
              show: false,
              alignWithLabel: true,
            },
            axisLabel: false,
            axisLine: false,
          },
        ],
        yAxis: {
          name: `(${yAxisName})`,
          nameTextStyle: {
            fontSize: 16,
            color: '#737373',
            align: 'right',
            padding: [ 0, 5, 10, 0 ],
          },
          boundaryGap: false,
          axisLabel: {
            color: '#737373',
            textStyle: {
              fontSize: 16,
              fontFamily: 'PingFangSC-Regular,PingFang SC',
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#EFEFEF',
            },
          },
        },
        series,
      }
    },
  },
}
</script>

<style lang="scss">
.observe-trend-satellite {
  position: relative;
  padding: 0 35px;
}
.observe-trend-satellite__chart {
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0,0,0,.2);
}

// 按钮
.observe-trend-satellite__switch-container {
  padding: 30px 25px;
  padding-bottom: 10px;
  font-family: PingFangSC-Medium,PingFang SC;
  font-size: 20px;
  font-weight: 500;
  color: #666;
}
.observe-trend-satellite__switch-btn {
  margin-right: 30px;
  &:hover {
    cursor: pointer;
  }
}
.observe-trend-satellite__switch-btn--active {
  font-size: 28px;
  color: #005EFF;
}
.observe-trend-satellite__switch-check {
  // position: absolute;
  // right: 50px;
  float: right;
}

.observe-trend-satellite__switch-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 46%;
  background-image: url(../../../assets/images/right.png);
  cursor: pointer;
  z-index: 2;
}
.observe-trend-satellite__switch-icon--left {
  left: 10px;
  transform: rotate(180deg);
}
.observe-trend-satellite__switch-icon--right {
  right: 10px;
}

.observe-trend-satellite__chart-container {
  height: 490px;
  position: relative;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  // div {
  //   width: 100%;
  //   height: 100%;
  //   display: inline-block;
  // }
}
</style>
